export const SMALL_SCREEN_BREAKPOINT = 'md'
export const MAXIMUM_REFERENCE_LENGTH = 9
